<template>
  <div style="background-color: white">
    <v-row class="primary-pattern">
      <v-row
        align="center"
        justify="center"
        class="mx-0"
        style="background-color: #d0d0d0"
      >
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="pt-6 d-flex justify-center align-center"
        >
          <div>
            <v-img
              src="/quejas/landing-12.png"
              :style="
                $vuetify.breakpoint.mdAndUp
                  ? 'margin-top: 20vh;margin-bottom: 20vh;'
                  : ''
              "
              heigth="20vh"
              width="40vw"
              contain
            ></v-img>
          </div>
        </v-col>
      </v-row>
    </v-row>
    <calidad></calidad>
    <v-container class="white pt-12">
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12" class="d-flex justify-center align-center">
          <v-card class="mb-12" style="background-color: #f7f7f7" width="100%">
            <v-layout
              :row="$vuetify.breakpoint.mdAndUp"
              class="mx-0"
              :column="$vuetify.breakpoint.smAndDown"
            >
              <v-flex
                xs12
                :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 ' : 'pa-2']"
              >
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" class="pr-6">
                      <iframe
                        src="https://docs.google.com/forms/d/e/1FAIpQLScLOoZyXxyjlTuf_EP38Vr4jpsVkzY4OMry2kT1pjP7BZ6YIg/viewform?embedded=true"
                        width="100%"
                        height="1204"
                        frameborder="0"
                        marginheight="0"
                        marginwidth="0"
                        >Cargando…</iframe
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar" :color="snackbarColor">
        {{ snackbarText }}
        <v-btn color="white" dark text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </v-container>
    <v-container style="background-color: white">
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12" class="pt-6 pb-12 d-flex justify-center align-center">
          <div>
            <v-img
              src="/quejas/landing_logotipos.png"
              heigth="auto"
              width="80vw"
              contain
            ></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style scoped>
.primary-pattern {
  height: 60vh;
  background-color: #d0d0d0;
  background-repeat: repeat;
}
</style>
<script>
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import axios from "axios";
import Calidad from "../components/Calidad";
export default {
  directives: {
    mask,
  },
  components: { Calidad },
  mounted() {},
  data: () => ({
    snackbar: false,
    snackbarColor: "info",
    snackbarText: "",
    fromlink: null,
    isLoading: false,
    publicPath: process.env.BASE_URL,
    campusSelected: "",
    offsetTop: 0,
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
      horarios: "",
      localidad: "",
      message: "Me interesa toda la información acerca de las promociones",
      licenciatura: false,
      posgrado: false,
      otros: false,
      preescolar: false,
      primaria: false,
      secundaria: false,
      preparatoria: false,
      escolaridad: "",
      school: "",
      way: "",
    },
  }),
  computed: {
    ...mapState({
      campus: (state) => state.cities.campus,
      campus_all: (state) => state.cities.campus,
      city_options: (state) => state.cities.city_options,
      city_selected: (state) => state.cities.city_selected,
      cities: (state) => state.cities.cities,
      vida: (state) => state.cities.vida,
      link_location: (state) => state.cities.link_location,
      link_information: (state) => state.cities.link_information,
    }),
    marginTop() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "-15vh";
      } else {
        ("-10vh");
      }
    },
  },
  methods: {
    validateEmail(email) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone =
        /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },
    validateFields() {
      if (
        this.information.name_first != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.campusSelected != "" &&
        this.information.localidad != "" &&
        this.information.message != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText =
          "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        this.snackbarColor = "dark";
      }
    },
    submit() {
      this.information.escolaridad = "";
      let escola = false;
      if (this.information.preescolar) {
        escola = true;
      }
      if (this.information.primaria) {
        escola = true;
      }
      if (this.information.secundaria) {
        escola = true;
      }
      if (this.information.preparatoria) {
        escola = true;
      }
      if (!escola) {
        this.snackbarText =
          "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        return;
      }
      this.validateFields();
      if (this.valid) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      if (this.valid && this.emailValid && this.phoneValid) {
        if (this.information.preescolar) {
          this.information.escolaridad += "Primaria ";
        }
        if (this.information.primaria) {
          this.information.escolaridad += "Preescolar ";
        }
        if (this.information.secundaria) {
          this.information.escolaridad += "Secundaria ";
        }
        if (this.information.preparatoria) {
          this.information.escolaridad += "Preparatoria ";
        }
        this.sendInfoData();
      }
    },
    sendInfoData() {
      let self = this;
      self.isLoading = true;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("phone", this.information.phone);
      formData.append("municipality", this.information.localidad);
      formData.append("campus", this.campusSelected);
      formData.append("message", this.information.message);
      formData.append("carreer", "Día V");
      formData.append("subject", "Día V - Informes");
      formData.append("information_by_level", this.information.escolaridad);
      formData.append("procedence", "Día V");
      formData.append("comunication", "Día V");
      formData.append("webpage", "Colegio");
      axios({
        method: "post",
        url: "https://informesuva.tidingo.com/api/create-information",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        },
      })
        .then(function (response) {
          if (response.data.status == 200) {
            self.snackbarText =
              "Información enviada, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.snackbar = true;
            self.clearFields();
          } else {
            self.snackbarText =
              "Ocurrio un error al enviar tu información, intentalo mas tarde";
            self.snackbarColor = "error";
            self.snackbar = true;
            self.clearFields();
          }
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    clearFields() {
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        phone: "",
        email: "",
        campus: "",
        carrer: "",
        horarios: "",
        localidad: "",
        message: "Me interesa toda la información acerca de las promociones",
        licenciatura: false,
        posgrado: false,
        otros: false,
        escolaridad: "",
        school: "",
        way: "",
      };
    },
    onScroll(e) {
      this.offsetTop = window.scrollY;
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
